import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class AccountReceivableAgingReportService {
  constructor(private http: HttpUtilService) {}

  GetDataAccountReceivableAging(model: {
    FromDate: string;
    ToDate: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/GetDataAccountReceivableAging`,
      {
        model: model,
      },
    );
  }
}
